import React from 'react';
import compose from 'lodash/fp/compose';
import { withDevice, WithDeviceProps as IWithDeviceInjectedProps } from '@catalogo/core-connect/device';
import { useTestAB } from '@catalogo/core-experiments';
import { IInjectedProps } from './types';

export const withModalWarrantyExperiment = <P extends Record<string, unknown>>(
  Component: React.FC<P & IInjectedProps>
) => (props: P & IWithDeviceInjectedProps) => {
  const modalWarrantyExperiment =
    props?.device?.toLowerCase() === 'mobile' ? useTestAB('EXP_NS_01_MODAL_SERVICOS_PDP') : undefined;
  return <Component {...props} modalWarrantyExperiment={modalWarrantyExperiment} />;
};

export default compose(withDevice, withModalWarrantyExperiment);
